<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object
  }
})
</script>

<template>
  <div class="title2">
    <div class="title2__en" v-if="props.data.en">{{ props.data.en }}</div>
    <div class="title2__tw" v-if="props.data.tw">{{ props.data.tw }}</div>
  </div>
</template>

<style lang="scss" scoped>
.title2 {
  &__en {
    font-weight: 500;
    font-size: toRem(60);
    font-family: $font-TextaAlt;
    color: $color-gray-3;
    line-height: 1.2;
    @include max-media(480) {
      font-size: toRem(46);
    }
    @include max-media(375) {
      font-size: toRem(38);
    }
  }
  &__tw {
    font-size: toRem(28);
    font-weight: 500;
    color: $color-black-1;
    @include max-media(480) {
      font-size: toRem(22);
    }
  }
}
</style>
